/* eslint-disable import/prefer-default-export */
export const getAuthUserId = (user) => {
  if (!user?.sub) return null;
  const parts = String(user.sub).split('|');
  const provider = (parts[1] || '').toLowerCase();
  const idNum = parseInt(parts[2], 10);
  if (Number.isNaN(idNum)) return null;
  // Namespace Kick IDs to avoid collisions with Twitch numeric IDs
  if (provider === 'kick') return 2000000000 + idNum;
  return idNum;
};

// Return-to helper for Auth0 login; preserves the page the user started on.
export const getLoginReturnTo = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash || ''}`;
